// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3XbOq","inner":"Footer_inner__vqQ8O","nextIcon":"Footer_nextIcon__3gm_R","innerLeft":"Footer_innerLeft__3XmvC"};